"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectFilter = void 0;
var react_1 = __importStar(require("react"));
var Select_1 = require("../components/Select");
function SelectFilter(props) {
    var column = props.column;
    var filterValue = column.filterValue, setFilter = column.setFilter, filterSource = column.filterSource, fetchCatalog = column.fetchCatalog, fetchSelectDataByUrl = column.fetchSelectDataByUrl, lang = column.lang, columnType = column.columnType, filterField = column.filterField;
    var _a = react_1.useState([]), selectData = _a[0], setSelectData = _a[1];
    var filterType = 'select';
    react_1.useEffect(function () {
        if ((filterSource === null || filterSource === void 0 ? void 0 : filterSource.sourceType) === 'Catalog' && (filterSource === null || filterSource === void 0 ? void 0 : filterSource.value) && fetchCatalog) {
            fetchCatalog(filterSource.value, lang).then(function (catalog) {
                setSelectData(catalog.map(function (_a) {
                    var code = _a.code, title = _a.title;
                    return ({ id: code, title: title });
                }));
            });
        }
        if ((filterSource === null || filterSource === void 0 ? void 0 : filterSource.sourceType) === 'URL' && (filterSource === null || filterSource === void 0 ? void 0 : filterSource.value) && fetchSelectDataByUrl) {
            fetchSelectDataByUrl(filterSource.value).then(function (data) {
                if (Array.isArray(data)) {
                    var idTitleData = data.map(function (item) {
                        if (!!item.code && !item.id) {
                            var codeTitleItem = item;
                            return {
                                id: codeTitleItem.code,
                                title: codeTitleItem.title,
                            };
                        }
                        return item;
                    });
                    setSelectData(idTitleData);
                }
                else {
                    setSelectData(data);
                }
            });
        }
    }, [filterSource, fetchCatalog, lang, setSelectData, fetchSelectDataByUrl]);
    var handleChange = react_1.useCallback(function (e, value) {
        var newValue;
        if (value.length !== 0) {
            newValue = filterField
                ? { filterType: filterType, columnType: columnType, filterField: filterField, value: value }
                : { filterType: filterType, columnType: columnType, value: value };
        }
        setFilter(newValue);
    }, [setFilter]);
    return (react_1.default.createElement(Select_1.TTableSelectForFilter, { selectData: selectData, onChange: handleChange, values: !(filterValue === null || filterValue === void 0 ? void 0 : filterValue.value) ? [] : filterValue.value, label: column.shortHeader }));
}
exports.SelectFilter = SelectFilter;
